import { render, staticRenderFns } from "./IQAIResponse.vue?vue&type=template&id=ab8c8f02&scoped=true"
import script from "./IQAIResponse.vue?vue&type=script&setup=true&lang=js"
export * from "./IQAIResponse.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQAIResponse.vue?vue&type=style&index=0&id=ab8c8f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8c8f02",
  null
  
)

export default component.exports